import type { OnInit } from '@angular/core'
import { Component, inject, input } from '@angular/core'
import type { FormGroup } from '@angular/forms'
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-get-notifications-section',
  templateUrl: './get-notifications-section.component.html',
  imports: [FormsModule, ReactiveFormsModule, RouterLink, TranslatePipe],
})
export class GetNotificationsSectionComponent implements OnInit {
  private fb = inject(FormBuilder)

  /** Key for title translation */
  readonly titleKey = input<string>()

  /** Key for description translation */
  readonly descriptionKey = input<string>()

  /** Key for email placeholder translation */
  readonly emailPlaceholderKey = input<string>()

  /** Key for button text translation */
  readonly buttonTextKey = input<string>()

  /** Key for email required error message translation */
  readonly emailRequiredKey = input<string>()

  /** Key for email invalid error message translation */
  readonly emailInvalidKey = input<string>()

  /** Key for success message translation */
  readonly successMessageKey = input<string>()

  /** Key for privacy agreement text translation */
  readonly privacyAgreementKey = input<string>()

  /** Key for privacy terms text translation */
  readonly privacyTermsKey = input<string>()

  /** Link to privacy terms page */
  readonly privacyTermsLink = input('/privacy-policy')

  /**
   * Whether the form is disabled (true by default until real implementation is
   * added)
   */
  readonly disabled = input(true)

  form!: FormGroup

  ngOnInit(): void {
    this.initForm()
  }

  private initForm(): void {
    // Create the control with disabled state specified at creation time
    this.form = this.fb.group({
      email: [
        { value: '', disabled: this.disabled() },
        [Validators.required, Validators.email],
      ],
    })
  }
}
